import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconWarningOutlineStyle0 = gravityIconIndividualCss;

const GravityIconWarningOutline = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '569be718d560d8274ad2921ab689134821bf6abf', color: this.color, size: this.size }, h("svg", { key: '88ff7b56a6cc3d0cab77b3ad6f7925ae07103194', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'a8168df4d817c1f984b6d512e3597a935569014c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.25 8a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V8Zm.75 6.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM2 11a9 9 0 0 1 9-9 9.01 9.01 0 0 1 9 9 9 9 0 1 1-18 0Zm16.5 0a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0Z", fill: "currentColor" }))));
    }
};
GravityIconWarningOutline.style = GravityIconWarningOutlineStyle0;

export { GravityIconWarningOutline as gravity_icon_warning_outline };

//# sourceMappingURL=gravity-icon-warning-outline.entry.js.map